import { Box, Card, Flex, Skeleton, Text } from '@radix-ui/themes';

export const HistoryItemCardSkeleton = () => {
    return (
        <Card size='2' variant='surface'>
            <Flex direction='column' gap='3'>
                <Flex justify='between' align='center'>
                    <Flex align='center' gap='2'>
                        <Skeleton>
                            <Box width='15px' height='15px' />
                        </Skeleton>
                        <Skeleton>
                            <Text size='2'>Loading Author</Text>
                        </Skeleton>
                    </Flex>
                    <Flex align='center' gap='2'>
                        <Skeleton>
                            <Box width='15px' height='15px' />
                        </Skeleton>
                        <Skeleton>
                            <Text size='1'>Loading Date Time</Text>
                        </Skeleton>
                    </Flex>
                </Flex>

                <Flex
                    justify='between'
                    align='center'
                    style={{
                        borderTop: '1px solid var(--gray-a4)',
                        paddingTop: 'var(--space-2)',
                    }}
                >
                    <Skeleton>
                        <Text size='2' as='div'>
                            X champs modifiés
                        </Text>
                    </Skeleton>
                    <Skeleton>
                        <Box width='15px' height='15px' />
                    </Skeleton>
                </Flex>
            </Flex>
        </Card>
    );
};
